import { jsx as _jsx } from "react/jsx-runtime";
import { createContext } from 'react';
export const AppConfigContext = createContext({
    config: {
        APP_NAME: 'TorqCloud',
        uiBaseURL: '',
        allowedReturnOrigins: [],
        torqCloudApiUrl: '',
        enableRegistration: true,
        enableDomainBasedRegistration: false,
        cognitoAdminConfirmation: false,
        cognitoUseUuidUsername: false,
    },
});
export const AppConfigProvider = (props) => {
    const { config, children } = props;
    return _jsx(AppConfigContext.Provider, { value: { config }, children: children });
};
//# sourceMappingURL=ConfigContext.js.map